<wiz-hgroup #argContainer width="100%" height="100%">
  
  <wiz-hgroup #lbl *ngIf="uselbl"  width="100%" height="100%"><!-- rendu d'un média du FDV-->
    <wiz-vgroup gap="0" [ngClass]="injectClass">
      <wiz-label id="label"
      [wizLabel]="alternateLabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
      <wiz-label id="inzone"
      [wizLabel]="compoValue"
      width="100%"
      ></wiz-label>
    </wiz-vgroup>
  </wiz-hgroup>

  <wiz-hgroup #cbx *ngIf="useCbx"  width="100%" height="100%"><!-- rendu checkbox-->
    <wiz-hgroup [ngClass]="injectClass" verticalAlign="center">
      <i class="fa-regular {{compoValue}} wiz-cell-bool" style="font-size: 18;"></i>
      <wiz-label id="label"
      [wizLabel]="alternateLabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
    </wiz-hgroup>
  </wiz-hgroup>


  <wiz-group #imgGp *ngIf="useimgGp"  width="100%" height="100%"><!-- rendu d'un média du FDV-->
    <wiz-vgroup gap="0" [ngClass]="injectClass" width="100%" height="100%">
      <wiz-label #imgLbl id="label" 
      [wizLabel]="alternateLabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
      <wiz-group width="100%" height="100%">
        <wiz-image
                #img
                tabindex="0"
                height="100%"
                width="100%"
                class="img-freestyle"
                [blobid]="imgBlobid"
                [sourceObservable]="imgSrcObs"
                style="pointer-events: none;"
                >
              ></wiz-image>
        <div style='z-index: 100; width:100%; height:100%; cursor: pointer;'
              wizholdable
              (wizHold)="seeImage($event, imgBlobid)"></div>
      </wiz-group>
    </wiz-vgroup>


  </wiz-group>

  <wiz-button #bt *ngIf="usebt" 
  class="button-connect"
  [wizLabel]="cnx?.trsLabel"
  [tooltipText]="cnx?.trsDescription"
  [wizImage]="cnx?.iconOrDie"
  width="100%" (wizClick)="doArgAction()"></wiz-button>

  <!-- html libre -->
  <wiz-hgroup #freeGrp *ngIf="usefreeGrp"  width="100%" height="100%">
    <angular-editor #ae width="100%" height="100%" style="pointer-events: none;"></angular-editor>
  </wiz-hgroup>
  
  <!-- image libre Embedded (en cache) -->
  <wiz-hgroup #freeImgGrp *ngIf="usefreeImgGrp" width="100%" height="100%">
    <wiz-image
        class="img-freestyle"
        [sourceObservable]="imgSrcObs"
        #freeImg
        tabindex="0"
        height="100%"
        width="100%"></wiz-image>
  </wiz-hgroup>

  <!-- rendu lien hypertexte sur un texte -->
  <wiz-hgroup #linkGp *ngIf="uselinkGp" width="100%" height="100%"> <!-- rendu texte du FDV au format hyperText-->
    <div><a href="{{linkUrl}}" target="_blank">{{linkLabel}}</a></div>
  </wiz-hgroup>

  <!-- rendu de type "media" sur un texte -->
  <wiz-hgroup #mediaGrp *ngIf="usemedia" [ngClass]="injectClass" width="100%" height="100%">
    <wiz-image
        class="img-freestyle"
        [source]="compoValue"
        #mediaImg
        tabindex="0"
        height="100%"
        width="100%"></wiz-image>
  </wiz-hgroup>

  <wiz-vgroup *ngIf="usecolor" width="100%" height="100%"  [ngClass]="injectClass">
    <wiz-label #colorLbl  
    [wizLabel]="alternateLabel" id="label"
    class="componentLabel" 
    [visible]="showLabel"></wiz-label>
    <span
      #cellBlockBack
      [style.backgroundColor]="compoValue"
      width="20px"
      height="20px"
      style="border-radius: 20px; border-style: solid; border-width: 1px"
    ></span>
  </wiz-vgroup>

  <!-- workflow -->
  <wiz-vgroup #workflowGroup *ngIf="useworkflow" width="100%" height="100%" [ngClass]="injectClass">
      <wiz-label #colorLbl id="label" 
      [wizLabel]="alternateLabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
    <wiz-hgroup width="100%" height="100%" id="inzone"
      verticalAlign="center">
        <wiz-image *ngIf="!!workImageBlob"
          class="img-freestyle"
          [sourceObservable]="workImage"
          #workImg
          tabindex="0"
          height="90%"
          style="aspect-ratio: 1;"
          ></wiz-image>
      
        <wiz-icon class="image-purple-nohover" *ngIf="!!workIcon">
          <mat-icon class="material-symbols-outlined">{{workIcon}}</mat-icon></wiz-icon>
      <wiz-vgroup width="100%" height="100%" horizontalAlign="center" verticalAlign="center" style="padding-right: 5px;">
        <wiz-hgroup width="100%" verticalAlign="center" style="overflow-y: auto;">
            <span class="wiz-cell-text" >{{workflowLabel}}</span>
        </wiz-hgroup>  
        
        <!-- <wiz-label #workflowLbl width="100%" 
          [wizLabel]="workflowLabel" style="align-items: center;">
          </wiz-label> -->  
          <!-- pièce jointe -->
          <wiz-hgroup #dropFull class="dropZone" *ngIf="workFile" 
                horizontalAlign="center" verticalAlign="center" style="
                padding: 5px"
                width="100%" height="30px">
                  <wiz-label [wizLabel]="workFile?.shortFileName" [wizTooltip]="workFile.fileName" width="100%"
                  style="word-break: break-all;"></wiz-label>
                  <wiz-vgroup width="28px">  
                    <wiz-icon #icoLoadWorkFile 
                    [undisableable]="true"
                    style="cursor: pointer; font-size: 20px" (click)="loadDropWorkFile()" [wizTooltip]="'$.common.export.$'">download</wiz-icon>
                  </wiz-vgroup>
                </wiz-hgroup>



      </wiz-vgroup>   
     </wiz-hgroup>
  </wiz-vgroup>

  <!-- images multiples -->
  <wiz-group #imgMultiGp *ngIf="useimgMultiGp" width="100%" height="100%" style="margin: 3px;"><!-- rendu d'un média mode multi-->
    <wiz-vgroup gap="0" [ngClass]="injectClass" width="100%" height="100%">
      <wiz-hgroup width="100%">
        <wiz-label #imgMultiLbl id="label"  
              [wizLabel]="alternateLabel"
              class="componentLabel" 
              [visible]="showLabel"></wiz-label>
      </wiz-hgroup>
     
      <!-- <div width="100%" height="100%" style="overflow-x: auto; overflow-y: hidden;"> -->
      <wiz-hgroup #imgMultiContainer gap="2" width="100%" height="100%" 
        style="overflow: auto hidden !important">
       

      <wiz-group *ngFor="let item of blobList"
        [style.width.px]="imageRatio" 
        [style.minWidth.px]="imageRatio"
        [style.height.px]="imageRatio" 
        
        >
          <wiz-image  
            tabindex="0"
            width="100%"
            height="100%"
            class="img-picker img-freestyle"
            [useHandCursor]="true"
            [blobid]="item[0]"
            [sourceObservable]="item[1]"
            style="pointer-events: none; user-select: none;"
            thumb="true"
            >
          </wiz-image>
          <div wizholdable style='z-index: 100; width:100%; height:100%; cursor: pointer;'
           
            (wizHold)="seeImage($event, item[0])"></div>
    
      </wiz-group>

      </wiz-hgroup>  
    </wiz-vgroup>
 
  </wiz-group>

  <!-- rendu liste de sous-éléments -->
  <wiz-hgroup #listGP *ngIf="uselistGP" width="100%" height="100%">
    <wiz-vgroup gap="0" [ngClass]="injectClass">
      <wiz-hgroup width="100%">
        <wiz-label #listLbl class="componentLabel" id="label" width="100%" 
        [wizLabel]="alternateLabel"
        [visible]="showLabel"></wiz-label>
      </wiz-hgroup>

      <div innerHTML="{{ compoValue }}" id="inzone"></div>
    </wiz-vgroup>  
  </wiz-hgroup>

  
</wiz-hgroup>
